module.exports = __webpack_public_path__ + "a18ee63829f2463f235dc568cb5c954d.png";